var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashStrong2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.828,
    height: 10.828,
    viewBox: "0 0 10.828 10.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_12427",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 12427",
    transform: "translate(1.414 1.414)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_832",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 832",
    x2: 8,
    y2: 8,
    fill: "none",
    stroke: "#979ea6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_833",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 833",
    x1: 8,
    y2: 8,
    fill: "none",
    stroke: "#979ea6",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashStrong2);
export default __webpack_public_path__ + "static/media/hash-strong_2.a7b7e30f1bb03577f8c25b71437f477d.svg";
export { ForwardRef as ReactComponent };